import Joi from 'joi';

export const playerCustomOptionSchema = Joi.object({
  uiOption: Joi.object({
    fullscreen: Joi.boolean().required(),
    speed: Joi.boolean().required(),
    quality: Joi.boolean().required(),
  }).required(),
  drm: Joi.number().required(),
  fullscreen: Joi.boolean(),
  trackWatchedSections: Joi.boolean(),
  logoPosition: Joi.string(),
  onlyProgress: Joi.boolean(),
  rewind: Joi.boolean(),
  playFullscreen: Joi.boolean(),
  seekStep: Joi.number(),
  mobileSizing: Joi.boolean(),
  mouseoverPlay: Joi.boolean(),
  speeds: Joi.array().items(Joi.number()),
  volume: Joi.number(),
  posterShadow: Joi.boolean(),
  allowRightClick: Joi.boolean(),
  noControls: Joi.boolean(),
  noSkip: Joi.boolean(),
  noSkipForward: Joi.boolean(),
  startTime: Joi.number(),
  related: Joi.boolean(),
  noControlbar: Joi.boolean(),
  exposeSpeedIcon: Joi.boolean(),
  abLoop: Joi.boolean(),
  pipIcon: Joi.string(),
  previewObject: Joi.any(),
  prevObject: Joi.any(),
  enableChat: Joi.boolean(),
  watermark: Joi.object({
    type: Joi.string().valid('random', 'duplicated'),
    amount: Joi.number(),
    size: Joi.number(),
    fontSize: Joi.number(),
    fontFamily: Joi.string(),
    color: Joi.string(),
    angleDeg: Joi.number(),
    enable: Joi.boolean(),
    label: Joi.string(),
    randomTiming: Joi.number(),
  }),
  addSkipBtn: Joi.boolean(),
  screenLock: Joi.boolean(),
  cachePlaybackRate: Joi.boolean(),
  appleCustomQuality: Joi.boolean(),
  deferBufferSpinner: Joi.boolean(),
  clickToPlayPause: Joi.boolean(),
  outroObject: Joi.string(),
  drmSecurityLevel: Joi.object({
    widevine: Joi.object({
      videoRobustness: Joi.string().valid(
        'HW_SECURE_ALL',
        'HW_SECURE_CRYPTO',
        'HW_SECURE_DECODE',
        'SW_SECURE_CRYPTO',
        'SW_SECURE_DECODE',
      ),
      audioRobustness: Joi.string().valid(
        'HW_SECURE_ALL',
        'HW_SECURE_CRYPTO',
        'HW_SECURE_DECODE',
        'SW_SECURE_CRYPTO',
        'SW_SECURE_DECODE',
      ),
    }),
    playready: Joi.object({
      videoRobustness: Joi.string().valid(
        'HW_SECURE_ALL',
        'HW_SECURE_CRYPTO',
        'HW_SECURE_DECODE',
        'SW_SECURE_CRYPTO',
        'SW_SECURE_DECODE',
      ),
      audioRobustness: Joi.string().valid(
        'HW_SECURE_ALL',
        'HW_SECURE_CRYPTO',
        'HW_SECURE_DECODE',
        'SW_SECURE_CRYPTO',
        'SW_SECURE_DECODE',
      ),
    }),
  }),
});

export const playerSkinOptionSchema = Joi.object({
  logoPosition: Joi.string(),
  controlbar: Joi.object({
    text: Joi.string(),
    icons: Joi.string(),
    iconsActive: Joi.string(),
    background: Joi.string(),
  }),
  timeslider: Joi.object({
    progress: Joi.string(),
  }).allow(null),
  progressbarColor: Joi.string(),
  playIconUrl: Joi.string().allow(null),
  customIcon: Joi.object({
    play: Joi.string(),
    pause: Joi.string(),
    fullscreen: Joi.string(),
    settings: Joi.string(),
    volume: Joi.string(),
  }),
  name: Joi.string(),
  captions: Joi.object({
    backgroundColor: Joi.string(),
    backgroundOpacity: Joi.number(),
    color: Joi.string(),
    fontFamily: Joi.string(),
    fontUrl: Joi.string(),
    fontOpacity: Joi.number(),
    fontSize: Joi.number(),
    windowColor: Joi.string(),
    windowOpacity: Joi.number(),
    letterSpacing: Joi.string(),
  }),
  playIconCustomCss: Joi.string(),
});
